export default "__VITE_ASSET__2lewCOmi__"